export default function BrandIntro() {
  return (
    <section id="brand" className="py-12 md:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4">
            브랜드 소개
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            "신체 활동으로 사고력을 깨우고, 창의적 사고력으로 성장을 완성하는 창의융합 교육"
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center mb-12 md:mb-20">
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/ea748a612c16eabbbe1d93412305ec80.jpg"
              alt="씽크짐창의융합놀이센터"
              className="w-full h-64 md:h-96 object-cover rounded-2xl shadow-xl"
            />
          </div>

          <div className="space-y-4 md:space-y-6">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-6">
              우리는 아이들의 <strong className="text-orange-500">창의적 성장</strong>을 돕습니다
            </h3>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed">
              &nbsp;신체 활동을 기반으로 '생각하는 힘'이 자라도록 설계된 프리미엄 창의융합 교육 공간입니다. 우리는 아이를 "운동시키는 곳"이나 "정답을 가르치는 곳"으로 만들지 않습니다. 아이가 움직이면서 관찰하고, 시도하고, 조절하고, 친구와 협력하는 과정 속에서 자연스럽게 창의력과 문제해결력, 자기조절력과 사회성이 함께 성장하도록 수업 구조를 설계합니다.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 md:w-20 md:h-20 mb-4 md:mb-6">
              <img
                src="https://readdy.ai/api/search-image?query=3D%20render%20of%20a%20glowing%20golden%20lightbulb%20with%20sparkles%20and%20rays%20of%20light%2C%20creative%20thinking%20concept%2C%20vibrant%20orange%20and%20yellow%20tones%2C%20soft%20shadow%2C%20isolated%20on%20white%20background%2C%20high%20quality%203D%20illustration%20style%2C%20cute%20and%20modern%20design&width=200&height=200&seq=3d-icon-creative-001&orientation=squarish"
                alt="창의적 사고"
                className="w-full h-full object-cover rounded-xl"
              />
            </div>
            <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-3 md:mb-4">창의적 사고</h4>
            <p className="text-sm text-gray-600 leading-relaxed">
              움직임 속에서 질문하고, 생각하고, 해결하는 힘을 기릅니다.&nbsp;놀이와 과제를 통해 아이의 사고 확장력과 문제해결력을 자연스럽게 자극합니다.
            </p>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="w-16 h-16 md:w-20 md:h-20 mb-4 md:mb-6">
              <img
                src="https://readdy.ai/api/search-image?query=3D%20render%20of%20a%20cute%20red%20heart%20with%20pulse%20heartbeat%20line%2C%20health%20and%20vitality%20concept%2C%20vibrant%20orange%20and%20red%20tones%2C%20soft%20shadow%2C%20isolated%20on%20white%20background%2C%20high%20quality%203D%20illustration%20style%2C%20glossy%20shiny%20surface%2C%20modern%20cute%20design&width=200&height=200&seq=3d-icon-health-002&orientation=squarish"
                alt="신체 발달"
                className="w-full h-full object-cover rounded-xl"
              />
            </div>
            <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-3 md:mb-4">신체 발달</h4>
            <p className="text-sm text-gray-600 leading-relaxed">
              연령별 발달에 맞춘 체계적인 신체 활동 프로그램으로
균형 잡힌 신체 발달과 기초 체력을 함께 키웁니다.
            </p>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow sm:col-span-2 lg:col-span-1">
            <div className="w-16 h-16 md:w-20 md:h-20 mb-4 md:mb-6">
              <img
                src="https://readdy.ai/api/search-image?query=3D%20render%20of%20three%20cute%20cartoon%20people%20figures%20holding%20hands%20together%2C%20teamwork%20and%20social%20connection%20concept%2C%20warm%20orange%20and%20yellow%20tones%2C%20soft%20shadow%2C%20isolated%20on%20white%20background%2C%20high%20quality%203D%20illustration%20style%2C%20friendly%20and%20cheerful%20design&width=200&height=200&seq=3d-icon-team-003&orientation=squarish"
                alt="사회성 발달"
                className="w-full h-full object-cover rounded-xl"
              />
            </div>
            <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-3 md:mb-4">사회성 발달</h4>
            <p className="text-sm text-gray-600 leading-relaxed">
              협동 과제와 팀 활동을 통해 소통하는 법, 조율하는 태도, 함께 성장하는 경험을 배웁니다.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
